export default __webpack_public_path__ + "clientapp/media/robot-03.f1973e4f.png";